import { createClient } from "@/utils/supabase/client";

// "Last seen changelog version" is stored in TWO places:
//   1. localStorage — immediate + reliable per-device. GoTrue caches
//      user_metadata in the JWT, so the server won't observe an updateUser()
//      change until the access token refreshes; localStorage closes that gap so
//      the modal never re-pops on the same device in the meantime.
//   2. auth user_metadata — cross-device + survives a localStorage clear.
// Client-only (touches localStorage + the browser supabase client).

export const CHANGELOG_LS_KEY = "last_seen_changelog";

export function hasSeenLocally(version: string): boolean {
  try {
    return localStorage.getItem(CHANGELOG_LS_KEY) === version;
  } catch {
    return false;
  }
}

export async function markChangelogSeen(version: string): Promise<void> {
  try {
    localStorage.setItem(CHANGELOG_LS_KEY, version);
  } catch {
    /* private mode / storage disabled */
  }
  try {
    await createClient().auth.updateUser({ data: { last_seen_changelog: version } });
  } catch {
    /* non-fatal: localStorage still guards this device */
  }
}
